import { render, staticRenderFns } from "./Page-SaleSimpleScreen.vue?vue&type=template&id=b3d58d70"
import script from "./Page-SaleSimpleScreen.vue?vue&type=script&lang=js"
export * from "./Page-SaleSimpleScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports